import { addLocation } from './add-location';
import { deleteLocation } from './delete-location';
import { fetchLocations } from './fetch-locations';
import { editLocation } from './edit-location';
import { loadingLocations } from './loading-locations';
import { setDefaultLocationsSorting } from './set-default-locations-sorting';
import { setLocations } from './set-locations';
import { updateLocationForManageUsers } from './update-location-for-manage-users';
import { updateLocationForSharedRoom } from './update-location-for-shared-room';
import { updateLocationsSorting } from './update-locations-sorting';
export default {
    addLocation,
    deleteLocation,
    editLocation,
    fetchLocations,
    loadingLocations,
    setDefaultLocationsSorting,
    setLocations,
    updateLocationForManageUsers,
    updateLocationForSharedRoom,
    updateLocationsSorting,
};
